<template>
  <div class="scroll">
    <div class="scroll-wrapper">
      <div v-if="userInfo.relation_bind_type == 1" class="head-title">
        <div class="left">
          <div class="main blue">
            家长协作
          </div>
        </div>
      </div>
      <div v-if="userInfo.relation_bind_type == 1" class="ewmbox">
        <img class="ewm" :src="previewImage" alt="" />
        <div class="msg">
          <div class="txt">家长绑定-班级二维码</div>
          <div @click="previewVisible = true" class="see blue">
            点击查看大图
          </div>
        </div>
      </div>
      <div class="head-title">
        <div class="left">
          <div class="main blue">
            家长认领照片
          </div>
        </div>
        <div class="btns" style="margin-top:0">
          <a-button @click="saveParent" type="danger" size="small"
            >保存任务</a-button
          >
          <a-button type="danger" @click="parentModal = true" size="small">
            保存并发布消息
          </a-button>
        </div>
      </div>
      <div class="content growup-content">
        <div class="list">
          <div class="head">
            <div class="left">
              <div class="student">姓名</div>
              <div class="number">编号</div>
            </div>
            <div class="right">
              <div
                v-for="(album, index2) in albumList"
                :key="index2"
                @click="selectAlbum(index2, 0)"
                class="cell"
              >
                {{ index2 + 1 }}
              </div>
            </div>
          </div>
          <div class="body">
            <div
              v-for="(student, index) in studentList"
              :key="index"
              class="students"
              :class="index % 2 ? 'hui' : ''"
            >
              <div
                @click="selectStudent(index, 0)"
                :class="student.select ? 'select' : ''"
                class="left"
              >
                {{ student.name }}
              </div>
              <div class="right">
                <div
                  v-for="(album, index2) in albumList"
                  :key="index2"
                  @click="toogleStudent(index2, index, 0)"
                  class="cell"
                >
                  <a-icon
                    v-if="album.studentList[index].select"
                    :style="{ color: '#67b0dc' }"
                    type="check-circle"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="head-title">
        <div class="left">
          <div class="main blue">
            家长上传照片
          </div>
        </div>
        <div class="btns" style="margin-top:0">
          <a-button @click="saveUpload" type="danger" size="small"
            >保存任务</a-button
          >
          <a-button type="danger" @click="uploadModal = true" size="small">
            保存并发布消息
          </a-button>
        </div>
      </div>
      <div class="content growup-content">
        <div class="list">
          <div class="head">
            <div class="left">
              <div class="student">姓名</div>
              <div class="number">编号</div>
            </div>
            <div class="right">
              <div
                v-for="(album, index2) in albumList"
                :key="index2"
                @click="selectAlbum(index2, 1)"
                class="cell"
              >
                {{ index2 + 1 }}
              </div>
            </div>
          </div>
          <div class="body">
            <div
              v-for="(student, index) in studentList2"
              :key="index"
              class="students"
              :class="index % 2 ? 'hui' : ''"
            >
              <div
                @click="selectStudent(index, 1)"
                :class="student.select ? 'select' : ''"
                class="left"
              >
                {{ student.name }}
              </div>
              <div class="right">
                <div
                  v-for="(album, index2) in albumList2"
                  :key="index2"
                  class="cell"
                  @click="toogleStudent(index2, index, 1)"
                >
                  <a-icon
                    v-if="album.studentList[index].select"
                    :style="{ color: '#67b0dc' }"
                    type="check-circle"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="head-title">
        <div class="left">
          <div class="main blue">
            成长册协作 {{ growList.length == 0 ? "(未发布可制作页码)" : "" }}
          </div>
        </div>
        <div v-if="growList.length" class="btns" style="margin-top:0">
          <a-button @click="saveGrow" type="danger" size="small"
            >保存任务</a-button
          >
          <a-button @click="growModal= true" type="danger" size="small">
            保存并发布消息
          </a-button>
        </div>
      </div>
      <div class="content growup-content">
        <div class="list">
          <div class="head">
            <div class="left">
              <div class="student">姓名</div>
              <div class="number">页码</div>
            </div>
            <div class="right">
              <div
                v-for="(album, index2) in growList"
                :key="index2"
                class="cell"
                @click="selectAlbum(index2, 2)"
              >
                {{ album.page_num }}
              </div>
            </div>
          </div>
          <div class="body">
            <div
              v-for="(student, index) in studentList3"
              :key="index"
              class="students"
              :class="index % 2 ? 'hui' : ''"
            >
              <div
                @click="selectStudent(index, 2)"
                :class="student.select ? 'select' : ''"
                class="left"
              >
                {{ student.name }}
              </div>
              <div v-if="growList.length" class="right">
                <div
                  v-for="(grow, index3) in growList"
                  :key="index3"
                  class="cell"
                  @click="toogleStudent(index3, index, 2)"
                >
                <a-icon
                    v-if="grow.studentList[index].select"
                    :style="{ color: '#67b0dc' }"
                    type="check-circle"
                  /></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <a-modal
      :visible="previewVisible"
      :footer="null"
      @cancel="previewVisible = false"
    >
      <div style="padding:20px">
        <img alt="example" style="width: 100%" :src="previewImage" />
      </div>
    </a-modal>
    <a-modal
      :visible="uploadModal"
      centered
      :closable="false"
      footer=""
      width="380px"
    >
      <div class="modal2">
        <div class="head">
          <img class="logo" :src="require('../assets/log2.png')" alt="" />
          <div class="msg">
            <div class="title">照片上传<br />协作</div>
          </div>
        </div>
        <div class="form2" style="margin-top:8px">
          <a-form-model>
            <a-form-model-item label="任务说明">
              <a-textarea
                placeholder="请简要说明本次任务内容"
                v-model="uploadForm.message"
                :rows="6"
              />
            </a-form-model-item>
          </a-form-model>
        </div>
        <div class="btns">
          <a-button @click="uploadModal = false">取消</a-button>
          <a-button @click="pushUpload" type="danger">
            确认
          </a-button>
        </div>
      </div>
    </a-modal>
    <a-modal
      :visible="parentModal"
      centered
      :closable="false"
      footer=""
      width="380px"
    >
      <div class="modal2">
        <div class="head">
          <img class="logo" :src="require('../assets/log2.png')" alt="" />
          <div class="msg">
            <div class="title">家长认领<br />协作</div>
          </div>
        </div>
        <div class="form2" style="margin-top:8px">
          <a-form-model>
            <a-form-model-item label="任务说明">
              <a-textarea
                placeholder="请简要说明本次任务内容"
                v-model="pushForm.message"
                :rows="6"
              />
            </a-form-model-item>
          </a-form-model>
        </div>
        <div class="btns">
          <a-button @click="parentModal = false">取消</a-button>
          <a-button type="danger" @click="pushParent">
            确认
          </a-button>
        </div>
      </div>
    </a-modal>
    <a-modal
      :visible="growModal"
      centered
      :closable="false"
      footer=""
      width="380px"
    >
      <div class="modal2">
        <div class="head">
          <img class="logo" :src="require('../assets/log2.png')" alt="" />
          <div class="msg">
            <div class="title">成长册<br />协作</div>
          </div>
        </div>
        <div class="form2" style="margin-top:8px">
          <a-form-model>
            <a-form-model-item label="任务说明">
              <a-textarea placeholder="请简要说明本次任务内容" v-model="growForm.message" :rows="6" />
            </a-form-model-item>
          </a-form-model>
        </div>
        <div class="btns">
          <a-button @click="growModal = false">取消</a-button>
          <a-button type="danger" @click="pushGrow">
            确认
          </a-button>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import _ from "lodash";
export default {
  data() {
    return {
      previewImage: "",
      previewVisible: false,
      parentModal: false,
      growModal: false,
      uploadModal: false,
      albumList: [],
      albumList2: [],
      studentList: [],
      studentList2: [],
      studentList3: [],
      growList: [],
      pushForm: {
        type: "is_claim",
        json: {},
        message: "",
      },
      uploadForm: {
        type: "is_up",
        json: {},
        message: "",
      },
      growForm: {
        json: {},
        message: "",
      },
    };
  },
  created() {
    if (this.userInfo) {
      this.previewImage = this.userInfo.qrcode;
      this.getStudent();
    }
  },
  watch: {
    userInfo(val) {
      if (val) {
        this.previewImage = this.$api.domain + this.userInfo.qrcode;
        this.getStudent();
        
      }
    },
  },
  computed: {
    ...mapState(["headers", "userInfo"]),
  },
  methods: {
    saveGrow() {
      this.filterJson("grow");
      if (JSON.stringify(this.growForm.json) == "{}") {
        console.log(JSON.stringify(this.growForm.json))
        this.$message.error("请先选择发布对象");
        return false;
      }
      this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.growCooperation,
        headers: { Authorization: this.$store.state.headers },
        data: {
          json:this.growForm.json,
          message:""
        }
      })
        .then((res) => {
          if (res.data.status == 200) {
            this.$message.success("保存成功");
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((res) => {
          this.$message.error(res.data.msg);
        });
    },
    pushGrow() {
      this.filterJson("grow");
      if (JSON.stringify(this.growForm.json) == "{}") {
        this.$message.error("请先选择发布对象");
        return false;
      }
      this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.growCooperation,
        headers: { Authorization: this.$store.state.headers },
        data: this.growForm,
      })
        .then((res) => {
          if (res.data.status == 200) {
            this.$message.success("发布成功");
            this.growModal = false;
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((res) => {
          this.$message.error(res.data.msg);
        });
    },
    saveParent() {
      this.filterJson("parent");
      if (JSON.stringify(this.pushForm.json) == "{}") {
        this.$message.error("请先选择发布对象");
        return false;
      }
      this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.parentCooperation,
        headers: { Authorization: this.$store.state.headers },
        data: {
          json:this.pushForm.json,
          type:this.pushForm.type
        }
      })
        .then((res) => {
          if (res.data.status == 200) {
            this.$message.success("保存成功");
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((res) => {
          this.$message.error(res.data.msg);
        });
    },
    pushParent() {
      this.filterJson("parent");
      if (JSON.stringify(this.pushForm.json) == "{}") {
        this.$message.error("请先选择发布对象");
        return false;
      }
      this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.parentCooperation,
        headers: { Authorization: this.$store.state.headers },
        data: this.pushForm,
      })
        .then((res) => {
          if (res.data.status == 200) {
            this.$message.success("发布成功");
            this.parentModal = false;
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((res) => {
          this.$message.error(res.data.msg);
        });
    },
    saveUpload() {
      this.filterJson("upload");
      if (JSON.stringify(this.uploadForm.json) == "{}") {
        this.$message.error("请先选择发布对象");
        return false;
      }
      this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.parentCooperation,
        headers: { Authorization: this.$store.state.headers },
        data: {
          json:this.uploadForm.json,
          type:this.uploadForm.type
        },
      })
        .then((res) => {
          if (res.data.status == 200) {
            this.$message.success("保存成功");
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((res) => {
          this.$message.error(res.data.msg);
        });
    },
    toogleStudent(index2, index, num) {
      switch (num) {
        case 0:
          this.albumList[index2].studentList[index].select = !this.albumList[
            index2
          ].studentList[index].select;
          break;
        case 1:
          console.log(this.studentList2);
          this.albumList2[index2].studentList[index].select = !this.albumList2[
            index2
          ].studentList[index].select;
          break;
        case 2:
          console.log(this.studentList3);
          this.growList[index2].studentList[index].select = !this.growList[
            index2
          ].studentList[index].select;
          break;
        default:
          break;
      }
      this.$forceUpdate();
    },
    filterJson(mode) {
      var json = {};
      switch (mode) {
        case "upload":
          this.albumList2.forEach((arr) => {
            arr.studentList.forEach((student) => {
              if (student.select) {
                if (!Object.hasOwnProperty.call(json, arr.id)) {
                  json[arr.id] = [student.id];
                } else {
                  json[arr.id] = [...json[arr.id], student.id];
                }
              }
            });
          });
          for (const key in json) {
            json[key] = json[key].join(",");
          }
          this.uploadForm.json = JSON.stringify(json);
          console.log(this.uploadForm);
          console.log(json);
          break;
        case "parent":
          this.albumList.forEach((arr) => {
            arr.studentList.forEach((student) => {
              if (student.select) {
                if (!json[arr.id]) {
                  json[arr.id] = [student.id];
                } else {
                  json[arr.id] = [...json[arr.id], student.id];
                }
              }
            });
          });
          for (const key in json) {
            json[key] = json[key].join(",");
          }
          this.pushForm.json = JSON.stringify(json);
          break;
        case "grow":
          this.growList.forEach((arr) => {
            arr.studentList.forEach((student) => {
              if (student.select) {
                if (!json[arr.guc_id]) {
                  json[arr.guc_id] = [student.id];
                } else {
                  json[arr.guc_id] = [...json[arr.guc_id], student.id];
                }
              }
            });
          });
          for (const key in json) {
            json[key] = json[key].join(",");
          }
          this.growForm.json = JSON.stringify(json);
          console.log(this.growForm)
          break;
        default:
          0;
          break;
      }
    },
    pushUpload() {
      this.filterJson("upload");
      if (JSON.stringify(this.uploadForm.json) == "{}") {
        this.$message.error("请先选择发布对象");
        return false;
      }
      this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.parentCooperation,
        headers: { Authorization: this.$store.state.headers },
        data: this.uploadForm,
      })
        .then((res) => {
          if (res.data.status == 200) {
            this.$message.success("发布成功");
            this.uploadModal = false;
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((res) => {
          this.$message.error(res.data.msg);
        });
    },
    selectAlbum(index, num) {
      switch (num) {
        case 0:
          console.log(this.studentList);
          this.albumList[index].studentList = this.albumList[index].studentList.map(arr=>{
            arr.select = !this.albumList[index].selectState
            return arr
          })
          this.albumList[index].selectState = !this.albumList[index].selectState
          this.$forceUpdate();
          break;
        case 1:
          console.log(this.studentList2);
          this.albumList2[index].studentList = this.albumList2[index].studentList.map(arr=>{
            arr.select = !this.albumList2[index].selectState 
            return arr
          })
          this.albumList2[index].selectState = !this.albumList2[index].selectState 
          this.$forceUpdate();
          break;
        case 2:
          console.log(this.studentList3);
          this.growList[index].studentList = this.growList[index].studentList.map(arr=>{
            arr.select = !this.growList[index].selectState 
            return arr
          })
          this.growList[index].selectState = !this.growList[index].selectState 
          this.$forceUpdate();
          break;
        default:
          break;
      }
    },
    selectStudent(index, num) {
      switch (num) {
        case 0:
          console.log(this.studentList);
          this.albumList.forEach(arr=>{
            arr.studentList[index].select = !this.studentList[index].selectState
          })
          this.studentList[index].selectState = !this.studentList[index].selectState
          this.$forceUpdate();
          break;
        case 1:
          console.log(this.studentList2);
          this.albumList2.forEach(arr=>{
            arr.studentList[index].select = !this.studentList2[index].selectState
          })
          this.studentList2[index].selectState = !this.studentList2[index].selectState
          this.$forceUpdate();
          break;
        case 2:
          console.log(this.studentList3);
          this.growList.forEach(arr=>{
            arr.studentList[index].select = !this.studentList3[index].selectState
          })
          this.studentList3[index].selectState = !this.studentList3[index].selectState
          this.$forceUpdate();
          break;
        default:
          break;
      }
    },
    getGrow() {
      this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.growupCooperation,
        headers: { Authorization: this.$store.state.headers },
      })
        .then((res) => {
          if (res.data.status == 200) {
            this.growList = res.data.data;
            this.growList = this.growList.map((arr) => {
              arr.studentList = _.cloneDeep(this.studentList3);
              return arr;
            });
            this.growForm.message =
              "请各位宝宝的家长协助完成，" +
              "成长册。模板我们已经设置，请各位家长不要随意改动，尽快完成！";
              this.getGrowSave()
          } else {
            // this.$message.error(res.data.msg);
          }
        })
        .catch((res) => {
          this.$message.error(res.data.msg);
        });
    },
    getGrowSave() {
      this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.growupCooperation2,
        headers: { Authorization: this.$store.state.headers },
      })
        .then((res) => {
          if (res.data.status == 200) {
            this.growList.forEach((grow,growIndex)=>{
              res.data.data.forEach(arr=>{
                if (grow.guc_id == arr.guc_id) {
                  if (arr.s_ids) {
                    let s_ids = arr.s_ids.split(',')
                    s_ids.forEach(id=>{
                      this.studentList3.forEach((student,studentIndex)=>{
                        if (student.id == id) {
                          this.growList[growIndex].studentList[studentIndex].select = true
                        }
                      })
                    })
                  }
                }
              })
            })
            this.$forceUpdate();
          } else {
            // this.$message.error(res.data.msg);
          }
        })
        .catch((res) => {
          this.$message.error(res.data.msg);
        });
    },
    getStudent() {
      this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.studentList,
        headers: { Authorization: this.$store.state.headers },
      })
        .then((res) => {
          this.studentList = res.data.data.rows;
          this.studentList = this.studentList.map((arr) => {
            arr.select = false;
            arr.selectState = false
            return arr;
          });
          this.studentList2 = _.cloneDeep(this.studentList);
          this.studentList3 = _.cloneDeep(this.studentList);
          this.getAlbum();
          this.getGrow();
        })
        .catch((res) => {
          this.$message.error(res.data.msg);
        });
    },
    getAlbum() {
      this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.albumList,
        headers: { Authorization: this.$store.state.headers },
        data: {
          class_id: this.userInfo.class_id,
          limit:200
        },
      })
        .then((res) => {
          if (res.data.status == 200) {
            this.albumList = res.data.data.data;
            this.albumList2 = _.cloneDeep(this.albumList);
            console.log(this.albumList)
            var name = [];
            this.albumList = this.albumList.map((arr) => {
              name = [...name, arr.name];
              arr.studentList = _.cloneDeep(this.studentList);
              var claimList = [];
              if (arr.is_claim) {
                 claimList = arr.is_claim.split(',')
              }
              claimList.forEach((claimid)=>{
                  arr.studentList.forEach((student,studentIndex)=>{
                    if (student.id == claimid) {
                      arr.studentList[studentIndex].select = true
                    }
                  })
              })
              return { ...arr };
            });
            this.albumList2 = this.albumList2.map((arr) => {
              arr.studentList = _.cloneDeep(this.studentList2);
              var upList = []
              if (arr.is_up) {
                upList = arr.is_up.split(',')
              }
              upList.forEach((upid)=>{
                    arr.studentList.forEach((student,studentIndex)=>{
                      if (student.id == upid) {
                        arr.studentList[studentIndex].select = true
                      }
                    })
                })
              return { ...arr };
            });
            this.pushForm.message =
              "请各位宝宝的家长认领，" +
              name.join("、") +
              "相册里宝宝的照片，尽快完成。谢谢各位家长配合！";
            this.uploadForm.message =
              "请各位宝宝的家长将宝宝的照片上传到" +
              name.join("、") +
              "相册里，尽快完成。谢谢各位家长配合！";
          }
        })
        .catch((res) => {
          console.log(res);
          this.$message.error("服务器或网络错误");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  width: 100%;
  height: 100%;
}
.modal2 .head .logo {
  width: 60px;
  height: 60px;
  margin-right: 10px;
}
.btns {
  display: flex;
  flex-direction: row;
  margin-top: 10px;
  justify-content: flex-end;
  .ant-btn {
    margin-left: 20px;
  }
}
::v-deep .ant-btn-primary {
  color: #fff;
  background-color: #67b0dc;
  border-color: #67b0dc;
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
}
::v-deep .ant-form-item {
  margin-bottom: 10px;
}
.modal2 .head .msg .title {
  color: #ff6a68;
  margin-bottom: 5px;
  font-size: 16px;
}
.ant-input:focus,
.ant-input:hover {
  border-color: #f39800;
}

.list {
  width: 100%;
  margin-top: 20px;
  .head {
    width: 100%;
    display: flex;
    flex-direction: row;
    .left {
      width: 100px;
      height: 32px;
      line-height: 32px;
      text-align: center;
      background: #f39800;
      color: #fff;
      margin: 0 1px 1px 0;
    }
    .right {
      display: flex;
      flex-direction: row;
      flex: 1 1 0%;
      .cell {
        width: 40px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        background: #f39800;
        color: #fff;
        margin: 0 1px 1px 0;
        cursor: pointer;
      }
    }
  }
  .body {
    width: 100%;
    .students {
      display: flex;
      flex-direction: row;
      .left {
        width: 100px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        background: #e4eaee;
        color: #898989;
        margin: 0 1px 1px 0;
        cursor: pointer;
        &.select {
          background: #67b0dc !important;
          color: #fff;
        }
      }
      .right {
        flex: 1 1 0%;
        display: flex;
        flex-direction: row;
        .cell {
          width: 40px;
          height: 32px;
          line-height: 32px;
          text-align: center;
          background: #e4eaee;
          color: #fff;
          margin: 0 1px 1px 0;
        }
      }
      &.hui .left {
        background: #dce2e6;
      }
      &.hui .right .cell {
        background: #dce2e6;
      }
    }
  }
}
.growup-content {
  width: 100%;
  .list {
    width: 100%;
    max-width: 100%;
    overflow-y: scroll;
    .left{
      flex: 0 0 100px;
    }
    .right{
      width: auto;
    }
  }
}
.ewmbox {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-top: 30px;
  .ewm {
    width: 120px;
    height: 120px;
  }
  .msg {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 120px;
    padding: 10px;
    box-sizing: border-box;
    .txt {
      color: #f39800;
      font-size: 20px;
    }
    .see {
      cursor: pointer;
    }
  }
}
.head-title {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  .left {
    flex: 1 1 0%;
    display: flex;
    flex-direction: row;
    align-items: center;
    .main {
      font-size: 16px;
    }
  }
  .right {
    flex: 1 1 0%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    .msg {
      display: flex;
      flex-direction: row;
      align-items: center;
      .txt {
        margin-right: 3px;
      }
    }
  }
}
.frame-list {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  margin-top: 30px;
  .addframe {
    width: 175px;
    margin-bottom: 30px;
    margin-right: 30px;
    cursor: pointer;
  }
  .addbox {
    width: 250px;
    height: 130px;
    border-radius: 0 20px 0 20px;

    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-right: 30px;
    margin-bottom: 30px;
    border: 3px dashed #67b0dc;
    cursor: pointer;
    .add {
      font-size: 40px;
    }
    .addtip {
      font-size: 20px;
      color: #67b0dc;
      margin-bottom: 16px;
    }
  }
  .cell {
    width: 175px;
    height: 120px;
    background: url("../assets/doc.png");
    background-size: 100% 100%;
    display: flex;
    flex-direction: row;
    padding: 25px 15px 15px 15px;
    margin-bottom: 30px;
    box-sizing: border-box;
    margin-right: 30px;
    .tx {
      width: 92px;
      height: 92px;
      margin-right: 20px;
    }
    &.select {
      border: 3px solid #67b0dc;
    }
    .msg {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .top {
        cursor: pointer;
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        color: #fff;
        font-size: 18px;
        img {
          width: 20px;
          margin-left: 10px;
        }
      }
      .foot {
        font-size: 14px;
        color: #fff;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-end;
        .order {
          font-size: 30px;
          line-height: 1;
        }
      }
    }
  }
}
.list .head .left {
  background-image: url("../assets/backline.png");
  background-size: 100% 100%;
  display: flex;
  flex-direction: row;
}
.list .head .left .student {
  font-size: 12px;
  color: #fff;
  line-height: 28px;
  margin-top: 6px;
  flex: 1 1 0%;
  cursor: pointer;
}
.list .head .left .number {
  font-size: 12px;
  color: #fff;
  margin-bottom: 10px;
  flex: 1 1 0%;
  line-height: 20px;
  cursor: pointer;
}
.scroll-wrapper {
  padding-bottom: 30px;
  box-sizing: border-box;
}
</style>
